/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  check: 'check_62b361b8',
  owner: 'owner_62b361b8',
  isSelected: 'isSelected_62b361b8',
  isVisible: 'isVisible_62b361b8',
  isDisabled: 'isDisabled_62b361b8',
};

export = styles;

loadStyles([{"rawString":".check_62b361b8{display:inline-block;cursor:default;box-sizing:border-box;vertical-align:top;background:0 0;border:none;opacity:0}.check_62b361b8::-moz-focus-inner{border:0}.check_62b361b8{outline:transparent}.check_62b361b8{position:relative}.ms-Fabric.is-focusVisible .check_62b361b8:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid "},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":"}.check_62b361b8:focus{opacity:1}button.check_62b361b8{padding:3px}.owner_62b361b8.isSelected_62b361b8 .check_62b361b8,.owner_62b361b8.isVisible_62b361b8 .check_62b361b8,.owner_62b361b8:focus .check_62b361b8,.owner_62b361b8:hover .check_62b361b8{opacity:1}.isDisabled_62b361b8{visibility:hidden}"}]);
/* tslint:enable */